// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2af0e64f","455":"722c84c6","977":"d4243ab5"}[chunkId] + ".chunk.js";
};